<template>
  <div class="bg-gray-700 pt-3 rounded-t-none rounded-lg">
    <div class="flex justify-around pt-2 pb-4">
      <div
        @click="
          setFilter('top10')
          $emit('closeMenu')
        "
        class="flex flex-col items-center cursor-pointer"
      >
        <div class="flex items-center pb-2">
          <img
            v-if="filter === 'top10'"
            class="w-8 h-8 cursor-pointer"
            src="../../assets/icons/top10FilterOn.svg"
            alt="Top 10 on"
          />
          <img v-else class="w-8 h-8 cursor-pointer" src="../../assets/icons/top10FilterOff.svg" alt="Top 10 off" />
        </div>
        <div class="text-base" :class="[filter === 'top10' ? 'text-white' : 'text-gray-600']">
          Top 10
        </div>
      </div>
      <div
        @click="
          setFilter('flop10')
          $emit('closeMenu')
        "
        class="flex flex-col items-center cursor-pointer"
      >
        <div class="flex items-center pb-2">
          <img
            v-if="filter === 'flop10'"
            class="w-8 h-8 cursor-pointer"
            src="../../assets/icons/flop10FilterOn.svg"
            alt="Flop 10 on"
          />
          <img v-else class="w-8 h-8 cursor-pointer" src="../../assets/icons/flop10FilterOff.svg" alt="Flop 10 off" />
        </div>
        <div class="text-base" :class="[filter === 'flop10' ? 'text-white' : 'text-gray-600']">
          Flop 10
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
  computed: {
    ...mapState({
      filter: state => state.grid.filter
    })
  },
  methods: {
    ...mapMutations("grid", ["setFilter"])
  }
}
</script>

<style></style>
